import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '@/layout/Index.vue'
// import Welcome from '@/views/Welcome.vue'
import Dictionary from '@/views/dictionary/Index.vue'
import DictionaryCreate from '@/views/dictionary/Create.vue'

import Apparatus from '@/views/apparatus/Index.vue'
import ApparatusCreate from '@/views/apparatus/Create.vue'

import Dynamic from '@/views/dynamic/Index.vue'
import DynamicCreate from '@/views/dynamic/Create.vue'

import Document from '@/views/document/Index.vue'
import DocumentCreate from '@/views/document/Create.vue'
import DocumentDetail from '@/views/document/Detail.vue'
import DocumentClassify from '@/views/document/Classify.vue'

import Script from '@/views/script/Index.vue'
import ScriptCreate from '@/views/script/Create.vue'

import Checkreport from '@/views/checkreport/Index.vue'
import CheckreportCreate from '@/views/checkreport/Create.vue'
import CheckreportDetail from '@/views/checkreport/Detail.vue'

import Checkinfo from '@/views/checkinfo/Index.vue'
import CheckinfoCreate from '@/views/checkinfo/Create.vue'

import Training from '@/views/training/Index.vue'
import TrainingCreate from '@/views/training/Create.vue'
import TrainingFilelist from '@/views/training/Filelist.vue'
import TrainingFilecreate from '@/views/training/Filecreate.vue'

import Advertising from '@/views/advertising/Index.vue'
import AdvertisingCreate from '@/views/advertising/Create.vue'
import Business from '@/views/business/Index.vue'
import BusinessCreate from '@/views/business/Create.vue'
import Industry from '@/views/industry/Index.vue'
import IndustryCreate from '@/views/industry/Create.vue'

import Maintenance from '@/views/maintenance/Index.vue'
import MaintenanceCreate from '@/views/maintenance/Create.vue'

import Workload from '@/views/workload/index.vue'
import Custvolume from '@/views/custvolume/Index.vue'

import Weight from '@/views/weight/index.vue'
import Unitmanage from '@/views/unitmanage/Index.vue'
import UnitmanageCreate from '@/views/unitmanage/Create.vue'

import Workplace from '@/views/workplace/Index.vue'

import Client from '@/views/client/Index.vue'

import Users from '@/views/users/Index.vue'
import UsersCreate from '@/views/users/Create.vue'

import Score from '@/views/file/score.vue'
import Qualified from '@/views/file/qualified.vue'
import CheckRate from '@/views/file/checkRate.vue'
import SteelDefects from '@/views/file/steelDefects.vue'
import standingBook from '@/views/file/standingBook.vue'
import checkStandingBook from '@/views/file/checkStandingBook.vue'

import QuestionInfo from '@/views/file/questionInfo.vue'

import DataRights from '@/views/dataRights/Index.vue'
import CreateDataRights from '@/views/dataRights/Create.vue'

import Message from '@/views/message/Index.vue'
import Banner from '@/views/banner/Index.vue'
import BannerCreate from '@/views/banner/Create.vue'
import Operacompany from '@/views/operacompany/Index.vue'
import OperacompanyCreate from '@/views/operacompany/Create.vue'
import Ourteam from '@/views/ourteam/Index.vue'
import OurteamCreate from '@/views/ourteam/Create.vue'
import Qualificationses from '@/views/qualificationses/Index.vue'
import QualificationsesCreate from '@/views/qualificationses/Create.vue'
import Product from '@/views/product/Index.vue'
import ProductCreate from '@/views/product/Create.vue'
import Recruit from '@/views/recruit/Index.vue'
import RecruitCreate from '@/views/recruit/Create.vue'
import Webofficial from '@/views/webofficial/Index.vue'
import WebofficialCreate from '@/views/webofficial/Create.vue'
import WebofficialPagelist from '@/views/webofficial/Pagelist.vue'
import TimeAxis from '@/views/timeAxis/Index.vue'

import Auths from '@/views/auths/Index.vue'
import AuthsCreate from '@/views/auths/Create.vue'

import Roles from '@/views/roles/Index.vue'
import RolesCreate from '@/views/roles/Create.vue'
import RoleRights from '@/views/roleRights/Index.vue'
import Login from '@/views/login/Index.vue'

Vue.use(VueRouter)

const routes = [
  // {
  //   path: '/',
  //   name: 'Login',
  //   component: Login
  // },
  {
    path: '/',
    component: Layout,
    //声明子组件
    // children: [{
    //     path: 'welcome',
    //     component: Welcome,
    children: [
      {
        path: 'dictionary',
        component: Dictionary,
        alias: '/',
        meta: {
          name1: '系统管理',
          name2: '字典管理',
          //需要登录的权限
          requireAuth: true
        }
      },
      {
        path: '/dictionary/create',
        component: DictionaryCreate,
        meta: {
          name1: '字典管理',
          name2: '字典创建',
          //需要登录的权限
          requireAuth: true
        }
      },
      {
        path: 'apparatus',
        component: Apparatus,
        alias: '/',
        meta: {
          name1: '基础维护',
          name2: '仪器管理',
          //需要登录的权限
          requireAuth: true
        }
      },
      {
        path: '/apparatus/create',
        component: ApparatusCreate,
        meta: {
          name1: '仪器管理',
          name2: '仪器创建',
          //需要登录的权限
          requireAuth: true
        }
      },
      {
        path: 'dynamic',
        component: Dynamic,
        alias: '/',
        meta: {
          name1: '基础维护',
          name2: '设备动态属性',
          //需要登录的权限
          requireAuth: true
        }
      },
      {
        path: '/dynamic/create',
        component: DynamicCreate,
        meta: {
          name1: '动态属性',
          name2: '动态属性创建',
          //需要登录的权限
          requireAuth: true
        }
      },
      {
        path: 'document',
        component: Document,
        alias: '/',
        meta: {
          name1: '基础维护',
          name2: '文档管理',
          //需要登录的权限
          requireAuth: true
        }
      },
      {
        path: '/document/create',
        component: DocumentCreate,
        meta: {
          name1: '文档管理',
          name2: '文档创建',
          //需要登录的权限
          requireAuth: true
        }
      },
      {
        path: '/document/detail',
        component: DocumentDetail,
        meta: {
          name1: '文档管理',
          name2: '文档编辑',
          //需要登录的权限
          requireAuth: true
        }
      },
      {
        path: '/document/classify',
        component: DocumentClassify,
        alias: '/',
        meta: {
          name1: '文档管理',
          name2: '标准分类',
          //需要登录的权限
          requireAuth: true
        }
      },
      {
        path: 'script',
        component: Script,
        alias: '/',
        meta: {
          name1: '基础维护',
          name2: '检测项判定脚本',
          //需要登录的权限
          requireAuth: true
        }
      },
      {
        path: '/script/create',
        component: ScriptCreate,
        meta: {
          name1: '判定脚本',
          name2: '判定脚本创建',
          //需要登录的权限
          requireAuth: true
        }
      },
      {
        path: 'checkreport',
        component: Checkreport,
        meta: {
          name1: '业务管理',
          name2: '检测模板管理',
          //需要登录的权限
          requireAuth: true
        }
      },
      {
        path: '/checkreport/create',
        component: CheckreportCreate,
        meta: {
          name1: '检测模板管理',
          name2: '模板创建',
          //需要登录的权限
          requireAuth: true
        }
      },
      {
        path: '/checkreport/detail',
        component: CheckreportDetail,
        meta: {
          name1: '检测模板管理',
          name2: '模板编辑',
          //需要登录的权限
          requireAuth: true
        }
      },
      {
        path: 'checkinfo',
        component: Checkinfo,
        meta: {
          name1: '业务管理',
          name2: '检测模板详情',
          //需要登录的权限
          requireAuth: true
        }
      },
      {
        path: '/checkinfo/create',
        component: CheckinfoCreate,
        meta: {
          name1: '检测模板详情',
          name2: '模板创建',
          //需要登录的权限
          requireAuth: true
        }
      },
      {
        path: 'training',
        component: Training,
        meta: {
          name1: '业务管理',
          name2: '培训附件管理',
          //需要登录的权限
          requireAuth: true
        }
      },
      {
        path: '/training/create',
        component: TrainingCreate,
        meta: {
          name1: '培训附件管理',
          name2: '目录创建',
          //需要登录的权限
          requireAuth: true
        }
      },
      {
        path: '/training/filelist',
        component: TrainingFilelist,
        meta: {
          name1: '培训附件管理',
          name2: '文件列表',
          //需要登录的权限
          requireAuth: true
        }
      },
      {
        path: '/training/filecreate',
        component: TrainingFilecreate,
        meta: {
          name1: '培训附件管理',
          name2: '文件创建',
          //需要登录的权限
          requireAuth: true
        }
      },
      {
        path: 'advertising',
        component: Advertising,
        meta: {
          name1: '业务管理',
          name2: '天宙动态',
          //需要登录的权限
          requireAuth: true
        }
      },
      {
        path: '/advertising/create',
        component: AdvertisingCreate,
        meta: {
          name1: '业务管理',
          name2: '天宙动态创建',
          //需要登录的权限
          requireAuth: true
        }
      },
      {
        path: 'business',
        component: Business,
        meta: {
          name1: '业务管理',
          name2: '业务动态',
          //需要登录的权限
          requireAuth: true
        }
      },
      {
        path: '/business/create',
        component: BusinessCreate,
        meta: {
          name1: '业务管理',
          name2: '业务动态创建',
          //需要登录的权限
          requireAuth: true
        }
      },
      {
        path: 'industry',
        component: Industry,
        meta: {
          name1: '业务管理',
          name2: '行业要闻',
          //需要登录的权限
          requireAuth: true
        }
      },
      {
        path: '/industry/create',
        component: IndustryCreate,
        meta: {
          name1: '业务管理',
          name2: '行业要闻创建',
          //需要登录的权限
          requireAuth: true
        }
      },
      {
        path: 'maintenance',
        component: Maintenance,
        meta: {
          name1: '业务管理',
          name2: '维保知识',
          //需要登录的权限
          requireAuth: true
        }
      },
      {
        path: '/maintenance/create',
        component: MaintenanceCreate,
        meta: {
          name1: '维保知识',
          name2: '知识创建',
          //需要登录的权限
          requireAuth: true
        }
      },
      {
        path: 'workplace',
        component: Workplace,
        // alias: '/',
        meta: {
          name1: '仪表盘',
          name2: '工作台'
        }
      },
      {
        path: 'workload',
        component: Workload,
        alias: '/workload',
        meta: {
          // requiresAuth: true,
          name1: '业务',
          name2: '工作量统计',
          //需要登录的权限
          requireAuth: true
        }
      },
      {
        path: '/custvolume',
        component: Custvolume,
        alias: '/custvolume',
        meta: {
          name1: '业务',
          name2: '客户报检量统计',
          //需要登录的权限
          requireAuth: true
        }
      },
      {
        path: '/weight',
        component: Weight,
        meta: {
          name1: '业务',
          name2: '权重配置',
          //需要登录的权限
          requireAuth: true
        }
      },
      {
        path: '/unitmanage',
        component: Unitmanage,
        alias: '/unitmanage',
        meta: {
          name1: '业务',
          name2: '单位管理',
          //需要登录的权限
          requireAuth: true
        }
      },
      {
        path: '/unitmanage/create',
        component: UnitmanageCreate,
        meta: {
          name1: '单位管理',
          name2: '单位创建',
          //需要登录的权限
          requireAuth: true
        }
      },

      {
        path: '/banner',
        component: Banner,
        alias: '/banner',
        meta: {
          name1: '官网',
          name2: '轮播图',
          //需要登录的权限
          requireAuth: true
        }
      },
      {
        path: '/banner/create',
        component: BannerCreate,
        meta: {
          name1: '官网',
          name2: '轮播图',
          //需要登录的权限
          requireAuth: true
        }
      },
      {
        path: '/qualificationses',
        component: Qualificationses,
        alias: '/qualificationses',
        meta: {
          name1: '官网',
          name2: '资质',
          //需要登录的权限
          requireAuth: true
        }
      },
      {
        path: '/qualificationses/create',
        component: QualificationsesCreate,
        meta: {
          name1: '官网',
          name2: '资质',
          //需要登录的权限
          requireAuth: true
        }
      },
      {
        path: '/operacompany',
        component: Operacompany,
        alias: '/operacompany',
        meta: {
          name1: '官网',
          name2: '合作伙伴',
          //需要登录的权限
          requireAuth: true
        }
      },
      {
        path: '/operacompany/create',
        component: OperacompanyCreate,
        meta: {
          name1: '官网',
          name2: '合作伙伴',
          //需要登录的权限
          requireAuth: true
        }
      },
      {
        path: '/ourteam',
        component: Ourteam,
        alias: '/ourteam',
        meta: {
          name1: '官网',
          name2: '我们的团队',
          //需要登录的权限
          requireAuth: true
        }
      },
      {
        path: '/ourteam/create',
        component: OurteamCreate,
        meta: {
          name1: '官网',
          name2: '我们的团队',
          //需要登录的权限
          requireAuth: true
        }
      },
      {
        path: '/message',
        component: Message,
        alias: '/message',
        meta: {
          name1: '官网',
          name2: '留言',
          //需要登录的权限
          requireAuth: true
        }
      },
      {
        path: '/product/create',
        component: ProductCreate,
        meta: {
          name1: '官网',
          name2: '产品',
          //需要登录的权限
          requireAuth: true
        }
      },
      {
        path: '/product',
        component: Product,
        alias: '/product',
        meta: {
          name1: '官网',
          name2: '产品',
          //需要登录的权限
          requireAuth: true
        }
      },
      {
        path: '/Recruit',
        component: Recruit,
        alias: '/recruit',
        meta: {
          name1: '官网',
          name2: '招聘',
          //需要登录的权限
          requireAuth: true
        }
      },
      {
        path: '/recruit/create',
        component: RecruitCreate,
        meta: {
          name1: '官网',
          name2: '招聘',
          //需要登录的权限
          requireAuth: true
        }
      },
      {
        path: '/Webofficial',
        component: Webofficial,
        alias: '/webofficial',
        meta: {
          name1: '官网',
          name2: '介绍',
          //需要登录的权限
          requireAuth: true
        }
      },
      {
        path: '/Webofficial/pagelist',
        component: WebofficialPagelist,
        meta: {
          name1: '官网',
          name2: '介绍',
          //需要登录的权限
          requireAuth: true
        }
      },
      {
        path: '/webofficial/create',
        component: WebofficialCreate,
        meta: {
          name1: '官网',
          name2: '介绍',
          //需要登录的权限
          requireAuth: true
        }
      },
      {
        path: '/timeAxis',
        component: TimeAxis,
        alias: '/timeAxis',
        meta: {
          name1: '官网',
          name2: '历程',
          //需要登录的权限
          requireAuth: true
        }
      },

      {
        path: '/file/score',
        component: Score,
        meta: {
          name1: '表格数据',
          name2: '检查得分统计',
          //需要登录的权限
          requireAuth: true
        }
      },
      {
        path: '/file/qualified',
        component: Qualified,
        meta: {
          name1: '表格数据',
          name2: '检测合格率',
          //需要登录的权限
          requireAuth: true
        }
      },
      {
        path: '/file/checkRate',
        component: CheckRate,
        meta: {
          name1: '表格数据',
          name2: '整改项比率',
          //需要登录的权限
          requireAuth: true
        }
      },
      {
        path: '/file/steelDefects',
        component: SteelDefects,
        meta: {
          name1: '表格数据',
          name2: '钢结构缺陷',
          //需要登录的权限
          requireAuth: true
        }
      },
      {
        path: '/file/questionInfo',
        component: QuestionInfo,
        meta: {
          name1: '表格数据',
          name2: '设备扣分详情',
          //需要登录的权限
          requireAuth: true
        }
      },
      {
        path: '/file/standingBook',
        component: standingBook,
        meta: {
          name1: '表格数据',
          name2: '检测业务台账',
          //需要登录的权限
          requireAuth: true
        }
      },
      {
        path: '/file/checkStandingBook',
        component: checkStandingBook,
        meta: {
          name1: '表格数据',
          name2: '检查业务台账',
          //需要登录的权限
          requireAuth: true
        }
      },
      {
        path: '/client',
        component: Client,
        meta: {
          name1: '客户',
          name2: '客户管理',
          //需要登录的权限
          requireAuth: true
        }
      },
      {
        path: '/users',
        component: Users,
        meta: {
          name1: '用户',
          name2: '用户管理',
          //需要登录的权限
          requireAuth: true
        }
      },
      {
        path: '/users/create',
        component: UsersCreate,
        meta: {
          name1: '用户管理',
          name2: '用户创建',
          //需要登录的权限
          requireAuth: true
        }
      },
      {
        path: '/datarights',
        component: DataRights,
        meta: {
          name1: '用户',
          name2: '数据权限',
          //需要登录的权限
          requireAuth: true
        }
      },
      {
        path: '/datarights/create',
        component: CreateDataRights,
        meta: {
          name1: '数据权限',
          name2: '创建数据权限',
          //需要登录的权限
          requireAuth: true
        }
      },
      {
        path: '/roles',
        component: Roles,
        meta: {
          name1: '角色',
          name2: '角色列表',
          //需要登录的权限
          requireAuth: true
        }
      },
      {
        path: '/rolerights',
        component: RoleRights,
        meta: {
          name1: '角色',
          name2: '角色权限',
          //需要登录的权限
          requireAuth: true
        }
      },
      {
        path: '/roles/create',
        component: RolesCreate,
        meta: {
          name1: '角色',
          name2: '角色创建',
          //需要登录的权限
          requireAuth: true
        }
      },

      {
        path: '/auths',
        component: Auths,
        meta: {
          name1: '权限',
          name2: '权限列表',
          //需要登录的权限
          requireAuth: true
        }
      },
      {
        path: '/auths/create',
        component: AuthsCreate,
        meta: {
          name1: '权限',
          name2: '权限创建',
          //需要登录的权限
          requireAuth: true
        }
      }
    ]
  },
  {
    path: '/login',
    component: Login
  }

  // {
  //   path: '/about',
  //   name: 'About',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import( /* webpackChunkName: "about" */ '../views/Info.vue')
  // }
]
// const workRoute = {
//   path: '/workload',
//   component: Workload,
//   alias: '/workload',
//   meta: {
//     // requiresAuth: true,
//     name1: '业务',
//     name2: '工作量统计'
//   }
// }
const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})
import store from '@/store'
// 路由守卫
// router.beforeEach((to, from, next) => {
//   const tokenStr = window.sessionStorage('token')
//   console.log(tokenStr)
//   if (!tokenStr) return next('/login')
//   next()
// })

router.beforeEach((to, from, next) => {
  if (['/login'].indexOf(to.path) != -1) {
    next()
  } else {
    if (to.meta.requireAuth) {
      let token = store.state.login.token
      // console.log(token)
      if (token) {
        next()
      } else {
        next({
          path: '/login'
        })
      }
    } else {
      next()
    }
  }
})

export default router
